import * as React from "react"

const SvgCodeFile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m8.998 16.071 1.393-1.393a.9.9 0 0 0 .284-.662.9.9 0 0 0-.284-.661.92.92 0 0 0-.673-.284.92.92 0 0 0-.673.284L6.99 15.41a.8.8 0 0 0-.2.307q-.06.165-.06.354t.06.355a.8.8 0 0 0 .2.307l2.055 2.055a.92.92 0 0 0 .673.283.92.92 0 0 0 .673-.283.9.9 0 0 0 .284-.662.9.9 0 0 0-.284-.66L8.998 16.07Zm6 0-1.394 1.394a.9.9 0 0 0-.283.662q0 .378.283.66a.92.92 0 0 0 .673.284.92.92 0 0 0 .674-.283l2.055-2.055a.8.8 0 0 0 .2-.307q.06-.166.06-.355t-.06-.354a.8.8 0 0 0-.2-.307l-2.056-2.055a.943.943 0 0 0-1.346 0 .9.9 0 0 0-.283.661q0 .378.283.662z" />
    <path
      fillRule="evenodd"
      d="M4.588 21.984q.587.587 1.412.587h12q.824 0 1.413-.587A1.93 1.93 0 0 0 20 20.571V9.396a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.588A1.93 1.93 0 0 0 4 4.57v16q0 .825.588 1.413ZM13 4.57v4a.97.97 0 0 0 .287.713q.288.287.713.287h4v11H6v-16z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCodeFile
